import { Injectable } from '@angular/core';
import { Ng2ImgMaxService } from 'ng2-img-max';
import { finalize, last } from 'rxjs/operators';
import { AngularFireStorage } from '@angular/fire/storage';
import { SwalService } from '../shared/swal.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ServerErrorMessage } from '../admin/login/login.component';
import { switchMap } from 'rxjs/internal/operators';

@Injectable({
  providedIn: 'root'
})
export class FileService {

  constructor(
    private ng2ImgMax: Ng2ImgMaxService,
    private storage: AngularFireStorage,
    private spinner: NgxSpinnerService,
    private swalService: SwalService
  ) {
  }

  uploadFile(file, prefixFileName) {
    return new Promise((res, rej) => {
      this.ng2ImgMax.resizeImage(file, 1900, 1080).subscribe(result => {
        const filePath = `${prefixFileName}-${new Date().getTime()}`;
        const ref = this.storage.ref(filePath);
        const task = ref.put(new File([result], result.name));

        task.snapshotChanges().pipe(
          last(),
          switchMap(() => ref.getDownloadURL())
        ).subscribe((url) =>{
          res(url);
        });

      }, () => {
        this.spinner.hide();
        this.swalService.openErrorMessage(ServerErrorMessage);
        rej();
      });
    });
  }

  removeFile(fileURL) {
    this.storage.storage.refFromURL(fileURL).delete();
  }

}
